import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

export interface DialogPaymentLeaveConfirmProps {
  /** 留在付款彈窗，僅關閉本確認框。 */
  onStay: () => void
  /** 確定離開：呼叫端負責取消付款並關閉付款彈窗。 */
  onLeave: () => void
}

export const DialogPaymentLeaveConfirm = ({ onStay, onLeave }: DialogPaymentLeaveConfirmProps) => {
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })

  return (
    <Dialog open fullWidth maxWidth={320}>
      <DialogHeader title={t('cartUi.paymentLeaveConfirmTitle', { defaultValue: '付款未完成' })} />
      <DialogContent>
        <Text align="center">
          {t('cartUi.paymentLeaveConfirmMessage', { defaultValue: '付款交易尚未完成，若離開此頁面，付款可能會被中斷或取消。確定離開頁面嗎？' })}
        </Text>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="grey" onClick={onStay} fullWidth>
          {t('cartUi.paymentLeaveConfirmStay', { defaultValue: '停留' })}
        </Button>
        <Button onClick={onLeave} fullWidth>
          {t('cartUi.paymentLeaveConfirmLeave', { defaultValue: '離開' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
